import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-site-page-header',
  templateUrl: './site-page-header.component.html',
  styleUrls: ['./site-page-header.component.scss']
})
export class SitePageHeaderComponent {
  @Input() titleKey = '';
  @Input() description = '';
  @Input() siteName = '';
  @Input() siteLinkEnabled = true;
  @Input() showBack = false;
  @Input() backLabel = 'ac_go_list';

  @Output() siteClick = new EventEmitter<void>();
  @Output() backClick = new EventEmitter<void>();
}
